import { PromotionType } from 'constants/enums/promotionType.enum';
import { PromotionTypeName } from 'constants/enums/promotionTypeName.enum';

/**
 * @description 優惠列表類型對應中文用
 */
const PromotionTypeDefines: Readonly<Record<PromotionType, PromotionTypeName>> = {
  [PromotionType.All]: PromotionTypeName.All,
  [PromotionType.Promotion]: PromotionTypeName.Promotion,
  [PromotionType.PrizeWinner]: PromotionTypeName.PrizeWinner,
  [PromotionType.ValueAdd]: PromotionTypeName.ValueAdd
};

export default PromotionTypeDefines;
